// FlowEditRouter.js
// Wrapper component that determines whether to show FlowEdit or SingleEventEdit
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress, Box } from '@mui/material';
import { fetchFlowWithDetailsAsync } from '../../redux/flows/getFlowsSlice';
import FlowEdit from './FlowEdit';
import SingleEventEdit from './SingleEventEdit';

export default function FlowEditRouter({ flowId }) {
  const dispatch = useDispatch();
  const [flowData, setFlowData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const loadFlow = async () => {
      setIsLoading(true);
      try {
        const result = await dispatch(fetchFlowWithDetailsAsync(flowId)).unwrap();
        setFlowData(result);
      } catch (error) {
        console.error('Error loading flow:', error);
      }
      setIsLoading(false);
    };

    loadFlow();
  }, [flowId, dispatch]);

  if (isLoading) {
    return (
      <Box
        sx={{
          p: 3,
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          size="4rem"
          sx={{
            color: 'secondary.main',
          }}
        />
      </Box>
    );
  }

  // Check if this is a Single Event flow
  if (flowData && flowData.flow_name === 'Single Event') {
    return <SingleEventEdit flowId={flowId} initialFlowData={flowData} />;
  }

  return <FlowEdit flowId={flowId} initialFlowData={flowData} />;
}
